import type { ColDef, ValueGetterParams } from 'ag-grid-enterprise'
import type { ValueProps } from '~/components/CellRenderers/SmallAppIconCellRenderer'
import type { IBadgeCellRendererParams } from '~/types/badge'
import type { IInApp, IInAppWithAppIconUrl } from '~/types/iap'

import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import InAppResumeCellRenderer from '~/components/CellRenderers/InAppResumeCellRenderer'
import SmallAppIconCellRenderer from '~/components/CellRenderers/SmallAppIconCellRenderer'
import { FASTLY_PATH } from '~/const/asset'
import { resize } from '~/utils/media'
import { badgeColDef } from '~/utils/table'

export interface IContext {
  onBadgeClick: (id: string) => void
}

const columns: ColDef[] = [
  {
    cellRenderer: SmallAppIconCellRenderer,
    headerName: 'App',
    minWidth: 66,
    resizable: false,
    sortable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
    valueGetter: ({ data }: ValueGetterParams<IInAppWithAppIconUrl>): ValueProps | undefined => {
      if (!data) return undefined

      const { app_icon_url, device_type } = data

      return {
        device_type: device_type,
        logo_url: resize(`${FASTLY_PATH}${app_icon_url}`, 48, 48),
      }
    },
    width: 66,
  },
  {
    cellRenderer: InAppResumeCellRenderer,
    headerName: 'In-App',
    sortable: false,
    suppressHeaderMenuButton: true,
  },
  badgeColDef(BadgeCellRenderer, {
    headerName: 'Offers',
    sortable: false,
    valueGetter: ({ context, data }: ValueGetterParams<IInApp>): IBadgeCellRendererParams | undefined => {
      if (!data) return undefined

      const { offers } = data

      return {
        data: offers?.map(({ name, offer_id }) => ({ id: offer_id, name: name })) || [],
        onBadgeClick: context.onBadgeClick,
        type: 'default',
      }
    },
  }),
]

export default columns
